import { render, staticRenderFns } from "./TakeDetail.vue?vue&type=template&id=45022334"
import script from "./TakeDetail.vue?vue&type=script&lang=js"
export * from "./TakeDetail.vue?vue&type=script&lang=js"
import style0 from "./TakeDetail.vue?vue&type=style&index=0&id=45022334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports